import { createSelector } from 'reselect';
import { APP } from '../index';
import { EVENT_UPDATES } from './index';

export const getEventUpdates = (state) => state[APP][EVENT_UPDATES];

export const getAttendeeTotal = createSelector(getEventUpdates, (eventUpdates) => eventUpdates.attendeeTotal);

export const getAreUpdatesLoading = createSelector(getEventUpdates, (eventUpdates) => eventUpdates.isLoading);
